import LazyImage from "../components/LazyImage";
import honda1 from "../assets/images/1.png?w=400;600;900;1200&format=webp&quality=75&effort=6&as=picture";
import honda2 from "../assets/images/2.png?w=400;600;900;1200&format=webp&quality=75&effort=6&as=picture";
import honda3 from "../assets/images/3.png?w=400;600;900;1200&format=webp&quality=75&effort=6&as=picture";

const BIKES = [
  { image: honda1, alt: "Honda motocross bike with Motographic graphics" },
  { image: honda2, alt: "Honda motocross bike graphics kit, side view" },
  { image: honda3, alt: "Honda motocross bike graphics kit, detail" },
];

const About = () => (
  <div className="p-10">
    <h1 className="title romanStandard text-sm">About</h1>
    <p className="romanStandard">
      Motographic has a reputation of producing top quality Motocross Graphics.
    </p>
    <p className="romanStandard">
      We only use top quality long lasting materials. Thick graphics with super
      aggressive adhesives that are specifically made for Motocross bikes.
    </p>
    <p className="romanStandard">
      Our product has been tested for over 10 YEARS to give you super hard
      wearing long lasting product that really sticks at a great price.
    </p>
    <p className="pt-5 romanStandard">
      We print your graphics using the latest digital printer technology to give
      clarity and rich vibrant colours.
    </p>
    <div className="lg:flex gap-5 pt-10">
      {BIKES.map(({ image, alt }) => (
        <LazyImage
          key={image.img.src}
          src={image.img.src}
          srcSet={image.sources.webp}
          sizes="(min-width: 1024px) 30vw, 90vw"
          width={image.img.w}
          height={image.img.h}
          alt={alt}
          className="lg:w-1/3 pb-5 lg:pb-0"
        />
      ))}
    </div>
  </div>
);

export default About;
